import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWarningTriangle = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 33,
	zoomAndPan: "magnify",
	viewBox: "0 0 17 13",
	height: 28,
	preserveAspectRatio: "xMidYMid meet",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
			id: "d2fd5291be",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M 0.175781 0 L 15.851562 0 L 15.851562 13.539062 L 0.175781 13.539062 Z M 0.175781 0 ",
				clipRule: "nonzero"
			})
		}), /* @__PURE__ */ _jsx("clipPath", {
			id: "45a639e766",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M 0.175781 0 L 15.851562 0 L 15.851562 13.539062 L 0.175781 13.539062 Z M 0.175781 0 ",
				clipRule: "nonzero"
			})
		})] }),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#d2fd5291be)",
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#ff3131",
				d: "M 15.023438 13.511719 C 15.019531 13.511719 15.019531 13.511719 15.015625 13.511719 L 0.800781 13.511719 C 0.582031 13.511719 0.382812 13.398438 0.273438 13.210938 C 0.167969 13.023438 0.167969 12.792969 0.273438 12.605469 L 7.382812 0.292969 C 7.492188 0.105469 7.691406 -0.0078125 7.90625 -0.0078125 C 8.125 -0.0078125 8.324219 0.105469 8.433594 0.292969 L 15.496094 12.527344 C 15.578125 12.628906 15.628906 12.761719 15.628906 12.90625 C 15.628906 13.242188 15.359375 13.511719 15.023438 13.511719 Z M 2.164062 12.277344 C 3.949219 12.277344 13.5625 12.277344 13.71875 12.277344 C 13.890625 12.277344 13.804688 12.105469 13.804688 12.105469 L 7.960938 1.984375 C 7.960938 1.984375 7.890625 1.871094 7.824219 1.980469 C 7.761719 2.078125 2.765625 10.734375 1.980469 12.097656 C 1.914062 12.210938 1.980469 12.277344 2.164062 12.277344 Z M 2.164062 12.277344 ",
				fillOpacity: 1,
				fillRule: "nonzero"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ff3131",
			d: "M 7.890625 8.792969 C 7.558594 8.792969 7.289062 8.527344 7.289062 8.195312 L 7.140625 5.609375 C 7.140625 5.167969 7.558594 4.867188 7.890625 4.867188 C 8.222656 4.867188 8.609375 5.167969 8.609375 5.566406 L 8.488281 8.195312 C 8.492188 8.527344 8.222656 8.792969 7.890625 8.792969 Z M 7.890625 8.792969 ",
			fillOpacity: 1,
			fillRule: "nonzero"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ff3131",
			d: "M 7.910156 9.523438 C 7.453125 9.523438 7.078125 9.898438 7.078125 10.355469 C 7.078125 10.816406 7.453125 11.1875 7.910156 11.1875 C 8.371094 11.1875 8.742188 10.816406 8.742188 10.355469 C 8.742188 9.898438 8.371094 9.523438 7.910156 9.523438 Z M 7.910156 9.523438 ",
			fillOpacity: 1,
			fillRule: "nonzero"
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#45a639e766)",
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#ff3131",
				d: "M 15.023438 13.511719 C 15.019531 13.511719 15.019531 13.511719 15.015625 13.511719 L 0.800781 13.511719 C 0.582031 13.511719 0.382812 13.398438 0.273438 13.210938 C 0.167969 13.023438 0.167969 12.792969 0.273438 12.605469 L 7.382812 0.292969 C 7.492188 0.105469 7.691406 -0.0078125 7.90625 -0.0078125 C 8.125 -0.0078125 8.324219 0.105469 8.433594 0.292969 L 15.496094 12.527344 C 15.578125 12.628906 15.628906 12.761719 15.628906 12.90625 C 15.628906 13.242188 15.359375 13.511719 15.023438 13.511719 Z M 2.164062 12.277344 C 3.949219 12.277344 13.5625 12.277344 13.71875 12.277344 C 13.890625 12.277344 13.804688 12.105469 13.804688 12.105469 L 7.960938 1.984375 C 7.960938 1.984375 7.890625 1.871094 7.824219 1.980469 C 7.761719 2.078125 2.765625 10.734375 1.980469 12.097656 C 1.914062 12.210938 1.980469 12.277344 2.164062 12.277344 Z M 2.164062 12.277344 ",
				fillOpacity: 1,
				fillRule: "nonzero"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ff3131",
			d: "M 7.890625 8.792969 C 7.558594 8.792969 7.289062 8.527344 7.289062 8.195312 L 7.140625 5.609375 C 7.140625 5.167969 7.558594 4.867188 7.890625 4.867188 C 8.222656 4.867188 8.609375 5.167969 8.609375 5.566406 L 8.488281 8.195312 C 8.492188 8.527344 8.222656 8.792969 7.890625 8.792969 Z M 7.890625 8.792969 ",
			fillOpacity: 1,
			fillRule: "nonzero"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ff3131",
			d: "M 7.910156 9.523438 C 7.453125 9.523438 7.078125 9.898438 7.078125 10.355469 C 7.078125 10.816406 7.453125 11.1875 7.910156 11.1875 C 8.371094 11.1875 8.742188 10.816406 8.742188 10.355469 C 8.742188 9.898438 8.371094 9.523438 7.910156 9.523438 Z M 7.910156 9.523438 ",
			fillOpacity: 1,
			fillRule: "nonzero"
		})
	]
});
export default SvgWarningTriangle;
